<div class="card recent-order">
  <div class="card-header card-no-border">
    <div class="header-top">
      <h5 class="m-0">{{ 'Recent Orders' | translate }}</h5>
      <div class="card-header-right-icon">
        <div class="dropdown icon-dropdown">
          <button class="btn dropdown-toggle" type="button" (click)="toggle()"><app-feather-icons [icon]="'more-horizontal'"></app-feather-icons></button>
          <div class="dropdown-menu dropdown-menu-end" [class.show]="show"><a class="dropdown-item" href="#">{{ 'Today' | translate }}</a><a class="dropdown-item" href="#">{{ 'Tomorrow' | translate }}</a><a class="dropdown-item" href="#">{{ 'Yesterday' | translate }}</a></div>
        </div>
      </div>
    </div>
  </div>
  <div class="card-body pt-0">
    <div class="recent-sliders">
      <div class="nav nav-pills" id="v-pills-tab" role="tablist">
        <button class="frame-box" type="button" [ngClass]="{ 'active show': openTab == 'shirt' }" (click)="tabbed('shirt')">
          <span class="frame-image"><img src="assets/images/dashboard-2/order/1.png" alt="vector shirt" /></span>
        </button>

        <button class="frame-box" type="button" [ngClass]="{ 'active show': openTab == 'television' }" (click)="tabbed('television')">
          <span class="frame-image"><img src="assets/images/dashboard-2/order/2.png" alt="vector television" /></span>
        </button>

        <button class="frame-box" type="button" [ngClass]="{ 'active show': openTab == 'headphone' }" (click)="tabbed('headphone')">
          <span class="frame-image"><img src="assets/images/dashboard-2/order/3.png" alt="vector headphone" /></span>
        </button>

        <button class="frame-box" type="button" [ngClass]="{ 'active show': openTab == 'chair' }" (click)="tabbed('chair')">
          <span class="frame-image"><img src="assets/images/dashboard-2/order/4.png" alt="vector chair" /></span>
        </button>

        <button class="frame-box" type="button" [ngClass]="{ 'active show': openTab == 'lamp' }" (click)="tabbed('lamp')">
          <span class="frame-image"><img src="assets/images/dashboard-2/order/5.png" alt="vector lamp" /></span>
        </button>
      </div>
      <div class="tab-content" id="v-pills-tabContent">
        <div class="tab-pane fade active" [ngClass]="{ 'show active': openTab == 'shirt' }">
          <app-product-table></app-product-table>
        </div>
        <div class="tab-pane fade" [ngClass]="{ 'show active': openTab == 'television' }">
          <app-product-table></app-product-table>
        </div>
        <div class="tab-pane fade" [ngClass]="{ 'show active': openTab == 'headphone' }">
          <app-product-table></app-product-table>
        </div>
        <div class="tab-pane fade" [ngClass]="{ 'show active': openTab == 'chair' }">
          <app-product-table></app-product-table>
        </div>
        <div class="tab-pane fade" [ngClass]="{ 'show active': openTab == 'lamp' }">
          <app-product-table></app-product-table>
        </div>
      </div>
    </div>
  </div>
</div>
